import { defineComponent as _defineComponent } from 'vue'
import { Partner } from 'ah-api-gateways';
import PartnerInformationEditor from '@/app/components/settings/PartnerInformationEditor.vue';
import { ref } from 'vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { getServices } from '@/app/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnerInformationSettingsView',
  setup(__props) {

const requestManager = useRequestManager().manager;
const services = getServices();
const currentPartner = ref<Partner | null>(null);

function loadPartner() {
  requestManager.currentOrNew('loadPartner', services.partner.getPartner()).subscribe((partner) => {
    currentPartner.value = partner;
  });
}

loadPartner();

return { __sfc: true,requestManager, services, currentPartner, loadPartner, PartnerInformationEditor }
}

})